import type { StatefulDiaryT } from "@/types/database/diaries";
import { buildMissingSideItems } from "../utils/buildMissingSideItems";
import { buildMissingDetails, type MissingDetailsSnapshot } from "../utils/missingDetailsBuilders";

export { isProcedureSideUnset } from "../utils/procedureSide";
export { isInjectionOrthopaedicUnset } from "../utils/missingDetailsBuilders";

export function useMissingDetails(diary: StatefulDiaryT): {
    missingDetails: MissingDetailsSnapshot;
    missingSideItems: ReturnType<typeof buildMissingSideItems>;
    hasMissingDetails: boolean;
} {
    const missingDetails = buildMissingDetails(diary);

    const missingSideItems = buildMissingSideItems(diary);

    const hasMissingDetails =
        (missingDetails.trackers.missingDate?.length ?? 0) > 0 ||
        (missingDetails.trackers.missingHospitalNumber?.length ?? 0) > 0 ||
        (missingDetails.injections.missingSide?.length ?? 0) > 0 ||
        (missingDetails.injections.missingOrthopaedicArea?.length ?? 0) > 0 ||
        (missingDetails.surgeries.missingSide?.length ?? 0) > 0 ||
        (missingDetails.shockwaves.missingSide?.length ?? 0) > 0 ||
        (missingDetails.shockwaves.missingOrthopaedicArea?.length ?? 0) > 0 ||
        missingSideItems.length > 0;

    return {
        missingDetails,
        missingSideItems,
        hasMissingDetails,
    };
}
